import React, { useEffect, useState } from "react";
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import data from "./Medium.json";

//
export function News(props: any) {
    const { t } = useTranslation();
    const theme = useTheme();
    const [page, setPage] = useState(0);
    const [news, setNews] = useState<any | null>(null);

    const handlePrevPage = () => {
        if (page - 1 >= 0) {
            setPage(page - 1);
        }
    }

    const handleNextPage = () => {
        if (page + 1 <= news.length - 1) {
            setPage(page + 1);
        }
    }

    // Get news from medium!
    useEffect(() => {
        async function getNews() {
            /*const MEDIUM_HEADER = {
                "Accept": "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*;q=0.8",
                "Accept-Encoding": "gzip, deflate, br",
                "Accept-Language": "en-US,en;q=0.5",
                "Connection": "keep-alive",
                "Host": "api.medium.com",
                "TE": "Trailers",
                "Upgrade-Insecure-Requests": "1",
                "User-Agent": "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:89.0) Gecko/20100101 Firefox/89.0"
            }*/

            //let rss= await parse(`https://cors-anywhere.herokuapp.com/https://medium.com/feed/@eternaldragons`, { header: MEDIUM_HEADER });



            //console.log("ITEMS", rss)

            let items: any = [];

            //@ts-ignore
            for (let i = 0; i < data.items.length; i++) {

                //@ts-ignore
                items[i] = data.items[i];
                items[i].descriptionExtracted = [];

                try {
                    //@ts-ignore
                    items[i].descriptionExtracted = items[i].description;
                }
                catch (e) {
                    console.log("Error exctracting medium description!")
                }
            }

            //console.log(items);
            //@ts-ignore
            setNews(items);
            //console.log(items)
        }

        getNews();
    }, []);


    //
    return (
        <Box id="eternal-dragons-team" className={props.className} style={{ padding: 0 }}>
            <Box>
                <img className="news-top-ornament" src="Ornament_SectionBreakHead.png" alt="team members top ornament" />
            </Box>

            <Typography className="home-whitebox-header">
                {t("home.latestNewsHeader")}
            </Typography>

            {
                news && news.length === 0 &&
                <Box style={{ padding: "100px", color: "#666666", fontSize: "20px" }}>
                    No News
                </Box>
            }

            {news && news.length > 0 &&
                <Box className="news-info-container" style={{ background: "" }}>
                    <ChevronLeftIcon className="news-list-arrow" onClick={handlePrevPage} sx={{ color: page > 0 ? "#333333" : "#cccccc" }} />

                    <Box className="news-info-cont">
                        <Box style={{ padding: "5px" }}>
                            <Box className="news-info-pubdate">{news[page].pubDate}</Box>
                            <Box className="news-info-title">{news[page].title}</Box>
                        </Box>

                        <Box className="news-info-content-cont">
                            <Box className="new-info-content-img-cont">
                                <img alt="news article image" src={news[page].thumbnail} style={{ maxWidth: "100%" }} />
                            </Box>

                            <Box className="news-info-content-desc">
                                {
                                    news[page].descriptionExtracted.map((el: string, index: number) => {
                                        return (
                                            <Box key={el} style={{ fontSize: "15px", marginTop: index === 0 ? 0 : "10px", lineHeight: 1.2 }}>{el}</Box>
                                        )
                                    })
                                }


                                <Box style={{ marginTop: "20px" }}>
                                    <a className="news-content-read-more" target="_blank" rel="noreferrer" href={news[page].link}>READ ARTICLE</a>
                                </Box>
                            </Box>
                        </Box>
                    </Box>

                    <ChevronRightIcon className="news-list-arrow" onClick={handleNextPage} sx={{ color: page <= news.length - 2 ? "#333333" : "#cccccc" }} />
                </Box>}
        </Box>
    );
}


// Default style!
const NewsStyled = styled(News)({
    marginTop: "50px",
    background: "white",
    height: "auto",
    //padding: "30px 20px 0px 20px",
    textAlign: "center",
    ".news-info-image": {
        maxHeight: "280px",
        height: "100%",
        border: "1px solid black"
    },
    ".news-info-container": {
        margin: "auto",
        //padding: "20px",
        maxWidth: "900px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
    },
    ".news-info-people-cont": {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center"
    },
    ['@media (max-width:900px)']: {
        ".news-info-image": {
            maxHeight: "200px",
            height: "100%",
            border: "1px solid black"
        }
    },
    ".news-top-ornament": {
        maxWidth: "800px",
        width: "100%",
        padding: "20px"
    },
    ".news-list-arrow": {
        cursor: "pointer",
        width: "50px",
        height: "50px",
        fontSize: "50px",
        position: "relative",
    },
    ".news-info-cont": {
        padding: 0,
        flexBasis: "100%",
        margin: "10px",
        minHeight: "310px"
    },
    ".news-info-pubdate": {
        fontSize: "14px",
        color: "#666666",
        textAlign: "left"
    },
    ".news-info-title": {
        fontSize: "19px",
        fontWeight: 700,
        color: "black",
        textAlign: "left",
        lineHeight: 1
    },
    ".news-info-content-cont": {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "left"
    },
    ".new-info-content-img-cont": {
        flexGrow: "0",
        maxWidth: "300px",
        background: "",
        padding: "5px"
    },
    ".news-info-content-desc": {
        flexGrow: "1",
        maxWidth: "450px",
        textAlign: "left",
        color: "#444444", padding: "5px"
    },
    ".news-content-read-more": {
        fontSize: "12px",
        textDecoration: "underline"
    }
});


export default NewsStyled;